import React, { useState } from "react";
import Spinner from "../shared/Spinner";
import Form from "./Form";
import Thanks from "./Thanks";
import { sendPasswordResetEmail } from "../../firebase/users";

type StatusType = "form" | "loading" | "done";

export default function ForgotPasswordPage() {
  const [status, setStatus] = useState<StatusType>("form");

  async function handleResetPassword(email: string) {
    setStatus("loading");
    await sendPasswordResetEmail(email);
    setStatus("done");
  }

  return (
    <>
      <Spinner isVisible={status === "loading"} />

      {status === "form" && <Form handleResetPassword={handleResetPassword} />}

      {status === "done" && <Thanks />}
    </>
  );
}
